import * as React from "react";

import { DetailContainer } from "../common/detail-container";

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TransferIcon from "@material-ui/icons/TransferWithinAStation";
import { ReleaseChangelog } from '../../../../../../../services/release-admin/types/release-changelog';
import { ReleaseIndexSchema } from '../../../../../../../services/search-admin/types/index-schema/release-index-schema';
import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface ReleaseDetailChangelogProps {
  changelog: ReleaseChangelog[]
  showDetails?: boolean;
  releases?: ReleaseIndexSchema[];
}

export const ReleaseDetailChangelog: React.FC<ReleaseDetailChangelogProps> = (
  props
) => {
  const isTransfer = (changelog: ReleaseChangelog): boolean => !!(changelog.reasons?.includes('transferred to') || changelog.reasons?.includes('Assigned to'))

  const releaseDetailsRow = (releaseId: string) => {
    const release = props.releases?.find((r) => r.id === releaseId);
    if (!release) {
      return null;
    }
    return (
      <div style={{display: 'flex', marginBottom: '0.5rem', fontWeight: 'bold'}}>
        <Typography style={{ fontWeight: 'bold' }}>
          <StyledLink to={`/releases/${releaseId}`}>{release.title}</StyledLink>
        </Typography>
        <Typography style={{margin: '0 .5rem'}}>|</Typography>
        <Typography style={{fontWeight: 'bold'}}>
          <StyledLink to={`/artists/${release.artist?.id}`}>{release.artist?.name}</StyledLink>
        </Typography>
        <Typography style={{margin: '0 0 0 .5em', fontWeight: 'bold'}}>({moment(release.releaseDate).format('L')})</Typography>
      </div>
    )
  }

  return (
    <DetailContainer style={{width: '100%'}}>
      {
        props.changelog.map((log, i) => (
          <Accordion key={i} defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              id={`panel-header-${i}`}
            >
              <div style={{width: '100%'}}>
                {props.showDetails ? (
                  releaseDetailsRow(log.releaseId)
                ) : null}
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  <Typography style={{ width: '150px' }}>{new Date(log.created_at).toDateString()}</Typography>
                  <Typography style={{ width: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>User:</b><br/>{log.editorEmail || '?'}</Typography>
                  <Typography style={{ width: '150px' }}><b>Status:</b><br/>{log.releaseStatus}</Typography>
                  <Typography style={{ width: '150px' }}><b>Backoffice Status:</b><br/>{log.backofficeStatus || '-'}</Typography>
                  { isTransfer(log) ? <TransferIcon /> : null }
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {log.reasons ? <Typography style={{whiteSpace: 'pre-line'}}>{log.reasons}</Typography> : null}
            </AccordionDetails>
          </Accordion>
        ))
      }
    </DetailContainer>
  );
};

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`